import { ILatitudeAndLongitude } from './location'

export enum GoinZoneType {
  SERVICE_ZONE = 'Service',
  PICKUP = 'Pickup',
  DROPOFF = 'Dropoff',
  HUB = 'Hub',
  VISIBILTY_AREA = 'Visibility Area',
  DESIGNATED_HOTSPOT = 'Designated Hotspot'
}

export enum GoinZoneShapeType {
  SHAPE_POLYGON = 'shape_polygon',
  SHAPE_CIRCLE = 'shape_circle',
  SHAPE_MULTIPOLYGON = 'shape_multipolygon',
  SHAPE_POINT = 'shape_point'
}

export enum GeoJsonShapeType {
  SHAPE_POLYGON = 'Polygon',
  SHAPE_CIRCLE = 'Circle',
  SHAPE_MULTIPOLYGON = 'MultiPolygon',
  SHAPE_POINT = 'Point'
}

export interface IGoinZoneObject {
  id: string
  geojson: number[][][] | null
  coordinates: { lat: number; lng: number }
  radius: number
  name: string
  address: string
  description: string
  price: number
  type: GoinZoneShapeType | GeoJsonShapeType
  zoneType: GoinZoneType
  color: string
  mapObject: any | null
  pointType: string
  visible: boolean
  zoneId?: string
}

export interface IZoneObject {
  id?: string
  organizationId: string
  serviceId: string
  name: string
  color: string
  type: GoinZoneType
  shapeType: GoinZoneShapeType | GeoJsonShapeType
  description?: string
  address?: string
  radius?: number
  center?: {
    type: string
    coordinates: number[]
  }
  shape?: {
    type: string
    coordinates: number[][][]
  } | null
  visible?: boolean
  zoneId?: string
  coordinates?: ILatitudeAndLongitude
}



// WEBPACK FOOTER //
// ./src/types/goinzone.ts